import axios from 'axios'
export default class Tokenize {
  static async tokenize(data) {
    console.log(`data:`, data)
    return axios.post(
      'https://api.freepay.az/api/tokenization/tokenize',
      data.body,
      {
        headers: data.headers,
      },
    )
  }
}
